import BaseHeaderMenuComponent from "./base-header-menu/base-header-menu-component";
import SectionsHeaderMenuComponent from "./sections-header-menu/sections-header-menu-component";

export default { BaseHeaderMenuComponent, SectionsHeaderMenuComponent };
